import {
  FlatFareConfigMap,
  FlightProduct,
} from "./flatFareProduct.types"

export const getFlatFareRouteKey = (airline: string, route: string) =>
  `${airline}_${route}`

export const parseFlatFareProducts = (products: FlightProduct[]): FlatFareConfigMap => {
  const map: FlatFareConfigMap = {}

  for (const product of products) {
    if (product.isEnable === false) {
      continue
    }

    const programs = product.configs?.flatFarePrograms || []
    for (const program of programs) {
      if (program.enabled === false) {
        continue
      }

      const conditions = program.conditions || {}
      const airline = conditions.airline || product.productCode

      for (const tier of program.flatFareRoutes || []) {
        for (const routeItem of tier.routes || []) {
          const route = `${routeItem.origin}${routeItem.destination}`
          map[getFlatFareRouteKey(airline, route)] = {
            airline,
            fareAmount: tier.fareAmount,
            totalDiscountAmount: tier.totalDiscountAmount,
            minPriceDiff: conditions.minPriceDiff ?? 200000,
            maxLegs: conditions.maxLegs ?? 1,
            excludeFlightWithinHours: conditions.excludeFlightWithinHours,
            clientId: conditions.clientId,
          }
        }
      }
    }
  }

  return map
}
